/**
 * View component for /user-profiles/:userProfileId
 *
 * Displays a single userProfile from the 'byId' map in the userProfile reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as userProfileActions from '../userProfileActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userProfile components
import UserProfileLayout from '../components/UserProfileLayout.js.jsx';

// import userProfile css modules
import userProfileStyles from '../userProfileModuleStyles.css';


class SingleUserProfile extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userProfileActions.fetchSingleIfNeeded(match.params.userProfileId));
  }

  render() {
    const { userProfileStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual userProfile object from the map
     */
    const selectedUserProfile = userProfileStore.selected.getItem();

    const isEmpty = (
      !selectedUserProfile
      || !selectedUserProfile._id
      || userProfileStore.selected.didInvalidate
    );

    return (
      <UserProfileLayout>
        <div className="flex">
          <Helmet
            title={"Profile | Pro-ficiency"}
          />
          <section className="section">
            <div className="yt-container">
              <h3> Single User Profile </h3>
              {isEmpty ?
                (userProfileStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: userProfileStore.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedUserProfile.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE User Profile </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the UserProfile would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </UserProfileLayout>
    )
  }
}

SingleUserProfile.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    userProfileStore: store.userProfile
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleUserProfile)
);



// WEBPACK FOOTER //
// modules/userProfile/views/SingleUserProfile.js.jsx